<template>

<section id="newsletter" class="border-top-none post pt-1 text-left">
  <h2> <slot name="label">Newsletter</slot></h2>
  <form>
    <slot name="text">
    Trage hier deine E-Mail-Adresse ein, wenn wir Dich benachrichtigen sollen, sobald neue Livestreams zur Verfügung stehen.
    </slot>
    <div class="fields pt-1">
      <input type="hidden" name="newsletter" id="newsletter" />
      <div class="field">
        <input v-model="email" type="text" name="email" id="email" placeholder="E-Mail-Adresse"/>
      </div>
      <div class="field">
          <input type="checkbox" id="dsgvo-check-nl" name="dsgvocheck"  v-model="dsgvoChecked">
          <label for="dsgvo-check-nl">Ich habe die <router-link to="/datenschutz">Datenschutzbestimmungen</router-link> für die Verarbeitung meiner persönlichen Daten gelesen</label>
      </div>
      <div class="field">
        <input v-if="!emailWasSend" @click.stop.prevent="sendMail" :disabled="!(dsgvoChecked && !!email)" class="btnSendNotify" type="submit" value="Benachrichtigung erhalten" />
        <div v-else style="color:green"><slot name="success">Vielen Dank. Ab sofort werden wir Dich über kommende Live-Events auf dem Laufenden halten.</slot></div>
        <div v-if="error" style="color:red"><slot name="error">Uhhh da ist etwas schief gelaufen!<br>Bitte probiere es noch einmal oder schreibe uns, falls der Fehler bestehen bleibt. Tausend Dank</slot></div>
      </div>
    </div>
  </form>
</section>

</template>

<script>
export default {
  name: 'RTNewsletter',
  components:{
  },
  props:{
    stream_id:{
      type:String
    }
  },
  watch:{
  },
  data: function() {
    return {
      dsgvoChecked:false,
      emailWasSend:false,
      email:"",
      error:false
    };
  },
  computed:{

  },
  methods:{
       sendMail(){
        const bodyFormData = new FormData();
        bodyFormData.append('email', this.email);
        bodyFormData.append('newsletter',true);
        if(!this._.isEmpty(this.stream_id)){
          bodyFormData.append('stream_id',this.stream_id);
        }
        this.axios({
            method: 'post',
            url: '/email.php',
            data: bodyFormData,
            headers: {'Content-Type': 'multipart/form-data' }
            })
          .then(()=>{
              this.emailWasSend=true;
              this.error=false;
          })
          .catch((error)=>{
            console.log(error);
            this.emailWasSend=false;
            this.error=true;
          });
    },
  },

  mounted(){
  },
};
</script>

<style scoped type='text/css'>
.btnSendNotify{
  width:100%;
  max-width: 300px;
}
</style>